<template>

  <v-card width="100%">
    <v-card-title class="title">
      About
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout
          row
          wrap
        >

          <v-flex xs12>
            <markdown-editor
              v-model="about"
              :configs="editorConfigs"
            ></markdown-editor>
          </v-flex>

          <!-- <v-flex xs12>
            <div>Use Markdown Syntax for for formatting.
              <a target="_blank" href='https://goo.gl/51Q6vb'>Guide</a>
            </div>
            <div v-html="markdown" class="markdown"></div>
          </v-flex> -->

        </v-layout>
        <v-layout>
          <v-flex xs12>
            <v-spacer></v-spacer>
            <v-btn
              color="accent"
              @click.native="save"
            >Save</v-btn>
          </v-flex>
        </v-layout>

      </v-container>
    </v-card-text>

  </v-card>

</template>


<script>
import marked from "marked";

export default {
  data() {
    return {
      about: "",
      editorConfigs: {
        hideIcons: ["image"],
        toolbarTips: true,
        styleSelectedText: false
      }
    };
  },

  computed: {
    markdown() {
      return marked(this.about, { sanitize: true });
    }
  },

  mounted() {
    this.about = this.$store.getters.about;
  },

  methods: {
    save() {
      this.$store.dispatch("saveAbout", this.about);
    }
  }
};
</script>

<style>
.markdown {
  border: 1px solid #ccc;
  background: rgb(255, 255, 196);
  border-radius: 5px;
  padding: 10px;
  min-height: 100px;
}

.markdown ul,
.markdown ol {
  margin-left: 20px;
}
</style>




// WEBPACK FOOTER //
// src/pages/AboutPage.vue